import { Link } from "react-router-dom";
import { SwitchableData, P3dModel } from "./functions";
import copy from "copy-to-clipboard";
import { useContext, useEffect, useState } from "react";
import { SwitchableContext } from "./context";

export interface IndexItemProps {
  experience: SwitchableData;
}

function SwitchableIndexItem({ experience }: IndexItemProps) {
  const { dataType } = useContext(SwitchableContext);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeout = setTimeout(() => {
      if (timeout) {
        clearTimeout(timeout);
      }
      setCopied(false);
    }, 3000);
  }, [copied]);
  const ownURL = `/${dataType === "chairs" ? "massagechairs" : "saunas"}/${experience.id}`;
  const isSwitcher = experience.type === "switcher";
  const embedLink = `https://brand3d-ar.web.app/viewer/${dataType === "chairs" ? "massagechairs" : "saunas"}/${experience.id}`;
  return (
    <li className="experience-item" key={`experience-item-${experience.id}`}>
      <div className="experience-item-box">
        <Link to={ownURL}>
          <div
            className={`experience-item-preview ${isSwitcher ? "preview-switcher" : "preview-single"}`}
          >
            {experience.models
              .slice(0, 4)
              .map(
                ({ id, thumbnail }: P3dModel, index: number): JSX.Element => {
                  return (
                    <img
                      key={`thumbnail-${id}-${index}`}
                      alt={`${id}`}
                      src={`${thumbnail}`}
                    />
                  );
                },
              )}
          </div>
        </Link>
        <Link to={ownURL}>
          <div className="experience-item-title" title={experience.name}>
            {experience.name}
          </div>
        </Link>
        {embedLink ? (
          <div className="experience-item-ar-box">
            <button
              type="button"
              onClick={() => {
                copy(embedLink);
                setCopied(true);
              }}
              className="button experience-item-ar-button"
              title="Click to copy the link to this experience"
            >
              Copy Link
            </button>
          </div>
        ) : (
          ""
        )}
        <div
          className={`experience-message experience-message-success ${copied ? "visible" : ""}`}
        >
          Link copied to clipboard
        </div>
      </div>
    </li>
  );
}

export default SwitchableIndexItem;
